import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import BidCreationDocumentsSlice from "../slices/BidCreationDocumentsSlice";
import { BidCreationDocumentModel } from "../../models/BidCreationDocumentsModel";
import { RootState } from "../store";

export const bidCreationDocumentActions = BidCreationDocumentsSlice.actions;

// To set the uploaded documents
export const setDocument = (
  documents: BidCreationDocumentModel
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(bidCreationDocumentActions.setDocument(documents));
  };
};

// To remove document
export const removeDocument = (
  id: string
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return (dispatch) => {
    dispatch(bidCreationDocumentActions.removeDocument(id));
  };
};

// To remove document
export const resetDocuments = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return (dispatch) => {
    dispatch(bidCreationDocumentActions.resetDocuments());
  };
};
